module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-backoffice-note-list row column"
  }, [_c('base-list', {
    ref: "baseList",
    attrs: {
      "component": _vm.component,
      "dataLoader": _vm.loadZones,
      "showPerPageSelect": false
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2cc59e62!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/backoffice/InstructionList.vue
// module id = 2367
// module chunks = 1